var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49992 1.54016C4.94052 1.54016 2.04004 4.44065 2.04004 8.00004C2.04004 11.5594 4.94052 14.4599 8.49992 14.4599C12.0593 14.4599 14.9598 11.5594 14.9598 8.00004C14.9598 4.44065 12.0593 1.54016 8.49992 1.54016ZM11.1226 7.52847L8.84229 9.8088C8.74539 9.9057 8.62265 9.95092 8.49992 9.95092C8.37718 9.95092 8.25444 9.9057 8.15754 9.8088L5.87721 7.52847C5.68987 7.34113 5.68987 7.03106 5.87721 6.84372C6.06454 6.65638 6.37462 6.65638 6.56195 6.84372L8.49992 8.78168L10.4379 6.84372C10.6252 6.65638 10.9353 6.65638 11.1226 6.84372C11.31 7.03106 11.31 7.33467 11.1226 7.52847Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMore);
export default __webpack_public_path__ + "static/media/viewMore.e2fcea99f7940fda98f78fd54ffa3c72.svg";
export { ForwardRef as ReactComponent };